import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProfileComponent } from './profile/profile';
import { SharedModule } from '../shared/shared.module';
import { UserprofileComponent } from './userprofile/userprofile';

import { RetailersModule } from '../retailer/retails.module';


@NgModule({
  declarations: [
    ProfileComponent,
    UserprofileComponent,
    
  ],
  imports: [
    SharedModule,
    RetailersModule,
    IonicPageModule.forChild(ProfileModule),
    
  ],
  entryComponents: [
    
  ],
  exports: [
    ProfileComponent,
   
  ],
  schemas: [
   
    
  ]
})
export class ProfileModule {}



// WEBPACK FOOTER //
// ./src/app/profile/profile.module.ts